import { useRef, useEffect, useState } from "react";
import './policies.css';
import * as aserver from '../../APIClient';

const PolicyList = (props) => {
    const [policies, setPolicies] = useState(false);
    const [dueDate, setDueDate] = useState(null);
    const [overdue, setOverdue] = useState(null);

    function toLocal(dt) {
        if (!dt)
            return('2999-99-99');
        const tzoffset = (new Date()).getTimezoneOffset()*60*1000;
        dt = new Date(dt);
        return((new Date(dt.getTime()-tzoffset)).toISOString().slice(0, 10));
    }
 
    useEffect(() => {
        let interval;
        async function getPolicies() {
            try {
                let response = await aserver.get(`api/v2/coaches/${props.coachUUID}/policies${props.onlyActionable?'?onlyActionable=true':''}`);
                setPolicies(response.data.policies);
                for (let p of response.data.policies)
                    localStorage.removeItem(p.code);
                let dueDate = response.data.policies.map(p=>toLocal(p.dueAt)).sort()[0];
                let now = toLocal(new Date());
                let overdue = now>=dueDate;
                if (overdue&&props.onOverdue)
                    props.onOverdue();
                setOverdue(overdue);
                setDueDate(dueDate);
                interval = setInterval(()=>{
                    for (let p of response.data.policies) {
                        p.nowDone = localStorage.getItem(p.code);
                    }
                    setPolicies(JSON.parse(JSON.stringify(response.data.policies)));
                },2000)
            } catch (err) {
                console.log(err)
            }
        };
        getPolicies();
        return () => clearInterval(interval)
    }, [props.coachUUID]);

    return (
        <div>
            {!policies?<>Loading...</>:<>
            {policies.map((p,index)=><div key={index}>
                {p.title}  -&nbsp; 
                {p.nowDone?'done!':
                <a href={window.location.origin + (`/coachportal/policies/${props.coachUUID}/${p.uuid}`)} target="_blank" rel="noreferrer">{p.userActionDisplayText}</a>}
                <br></br></div>)}
            </>}
            {props.onlyActionable&&<div>
                <br></br>
                <span style={{color:"red"}}>Please sign / accept these policies before <b>{dueDate}</b> - from that date onwards, you'll only be able to access the rest of the Coach Portal after you've signed / accepted.</span>
                <br></br>
                <br></br>
                {overdue&&<div className="overdue">
                    <p className="modalNoteText">Note: signing is overdue. You cannot continue using the portal until you have signed / accepted the above.</p>
                    </div>}
            </div>}

        </div>
    )
};

export default PolicyList;
